import { render, staticRenderFns } from "./FullCard.vue?vue&type=template&id=4a6b5fcb&scoped=true"
import script from "./FullCard.vue?vue&type=script&lang=js"
export * from "./FullCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b5fcb",
  null
  
)

export default component.exports